// removed by extract-text-webpack-plugin
module.exports = {"subTotalContainer":"_2AvxZ7t","germanVATInc":"_3avmlO4"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/SubTotal/index.css
// module id = ./template/components/MiniBag/Footer/SubTotal/index.css
// module chunks = client.sitechrome